/**
 * Attendance presence-map helpers (feature: checkin-past-event-edit).
 *
 * Check-in / check-out are stored on the event record as presence maps of the
 * shape `{ [rider_id]: 1 }`. A rider is present iff their id is a key. There
 * are no timestamps — presence only.
 *
 * `setRiderPresence` is a pure function (does not mutate its input) so it can
 * host property-based tests (round-trip, idempotence, isolation, value
 * invariant).
 */

export type PresenceMap = Record<string, number>;

/**
 * Return a NEW presence map with `riderId` added (value 1) when `present` is
 * true, or removed when false. The input map is never mutated.
 */
export function setRiderPresence(
  map: PresenceMap,
  riderId: string,
  present: boolean
): PresenceMap {
  const next: PresenceMap = { ...map };
  if (present) {
    next[riderId] = 1;
  } else {
    delete next[riderId];
  }
  return next;
}

/**
 * Build a presence map from a boolean state record (e.g. the check-in/out
 * checkbox state), keeping only entries that are `true`.
 */
export function presenceMapFromBooleanState(
  state: Record<string, boolean>
): PresenceMap {
  const map: PresenceMap = {};
  for (const [riderId, checked] of Object.entries(state)) {
    if (checked) {
      map[riderId] = 1;
    }
  }
  return map;
}
